import { Modal, Table, Text } from '@mantine/core'

import UserDetails from '@/components/Details/UserDetails/UserDetails'
import classes from '@/components/Tables/WithdrawTable.module.css'
import { CurrentVote } from '@/hooks/useElectionsServer'
import { processBalance } from '@/utils/utils'

interface UserVotesModalProps {
  opened: boolean
  onClose: () => void
  votes: CurrentVote[]
  userId: string
}

const UserVotesModal: React.FC<UserVotesModalProps> = ({ opened, onClose, votes, userId }) => {
  const userVotes = votes.filter(vote => vote.user === userId)
  const totalAmount = processBalance(
    userVotes.reduce((acc, vote) => acc + BigInt(vote.amount), BigInt(0))
  )

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <UserDetails userId={userId} width="fit-content" />
          <Text>{totalAmount.display} VOTE Total</Text>
        </div>
      }
      size="lg"
    >
      <Table>
        <Table.Thead className={classes.tableHeader}>
          <Table.Tr>
            <Table.Th className={classes.tableHeader}>Candidate</Table.Th>
            <Table.Th className={classes.tableHeader}>Amount</Table.Th>
            <Table.Th className={classes.tableHeader}>Index</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {userVotes.map(vote => (
            <Table.Tr key={`${vote.candidate}-${vote.amount}-${vote.index}`}>
              <Table.Td className={classes.tableRow}>
                <UserDetails userId={vote.candidate} width="fit-content" />
              </Table.Td>
              <Table.Td className={classes.tableRow}>
                {processBalance(BigInt(vote.amount)).display}
              </Table.Td>
              <Table.Td className={classes.tableRow}>{vote.index}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Modal>
  )
}

export default UserVotesModal
